import { nebankaOcpRoutes } from './NebankaOcpParentPage/routes';
import { nebankaProductsRoute } from './NebankaProductsPage/route';
import { nebankaRoute } from './route';

export const nebankaRoutes = nebankaRoute.addChildren([
	nebankaProductsRoute,
	nebankaOcpRoutes,
]);
